import { Client, ClientData, CreateClientDto } from "../../types/client.types";
import { PaginationInputDto } from "../../model/common/PaginatedInputDto";
import { get, post, del } from "../../utils/BaseService";

export async function getAllClients(dispatch: any, props: PaginationInputDto):Promise<ClientData> {
  return await post(dispatch, '/client/getAllClients', props);
}

export async function updateClientGSTTreatment(dispatch: any, props: {clientId:number;gstTreatmentId:number;}):Promise<string> {
   const queryString = `?clientId=${props.clientId}&gstTreatmentId=${props.gstTreatmentId}`;
  const url = `/client/updateClientGSTTreatment${queryString}`;
  return await post(dispatch, url, null);
}

export async function getClientById(dispatch: any, id: string) {
  return await get(dispatch, `/client/getClientById/${id}`, null);
}

export async function createClient(dispatch: any, props: Partial<CreateClientDto>) {
  return await post(dispatch, "/client/createClient", props);
}

export async function updateClient(dispatch: any, id: string, props: Partial<Client>) {
  return await post(dispatch, `/client/updateClient/${id}`, props);
}

export async function deleteClient(dispatch: any, id: string) {
  return await del(dispatch, `/client/deleteClient`, parseInt(id));
}

export async function getEmailsByClientId(dispatch: any, id: string) {
  return await get(dispatch, `/client/getEmailsByClientId/${id}`, null);
}